import {AsyncPage, Empty} from 'Core/models/Async';
import {createAction} from 'Shared/utilities/actionCreator';
import {Page} from 'Core/models/Page';
import {pipe} from 'fp-ts/lib/pipeable';
import {fold as foldOption, fromNullable} from 'fp-ts/lib/Option';
import {constant} from 'fp-ts/lib/function';
import {PageFetchAction} from 'Shared/utilities/sagaApiGenerators';
import {Keyword} from 'GenericTexting/models/Keyword';

export enum KeywordActionType {
  GET_KEYWORDS = 'keyword/GET_KEYWORDS',
  CHANGE_KEYWORDS = 'keyword/CHANGE_KEYWORDS',
  CHANGE_KEYWORDS_FILTER = 'keyword/CHANGE_KEYWORDS_FILTER',
}

export const DefaultKeywordFilters: KeywordFilters = {
  pageSize: 0,
  clientName: '',
  keywordName: '',
};

export type KeywordFilters = {
  pageSize?: number;
  clientName: string;
  keywordName: string;
};

export const searchKeywords = (pageOption?: Page<Keyword>, filter?: KeywordFilters) => {
  const payload = pipe(
    fromNullable(pageOption),
    foldOption(constant(PageFetchAction.Initial({filter})), page =>
      PageFetchAction.Additional({existingPage: page, filter})
    )
  );
  return createAction(KeywordActionType.GET_KEYWORDS, payload);
};

export const changeKeywords = (keywordReports: AsyncPage<Page<Keyword>>) =>
  createAction(KeywordActionType.CHANGE_KEYWORDS, keywordReports);

export const changeKeywordsFilters = (filters: KeywordFilters) =>
  createAction(KeywordActionType.CHANGE_KEYWORDS_FILTER, {filters});

type KeywordState = {
  keywordPage: AsyncPage<Page<Keyword>>;
  filter: KeywordFilters;
};

export const DEFAULT_STATE: KeywordState = {
  keywordPage: new Empty(),
  filter: DefaultKeywordFilters,
};

type KeywordAction =
  | ReturnType<typeof searchKeywords>
  | ReturnType<typeof changeKeywords>
  | ReturnType<typeof changeKeywordsFilters>;

export default (state: KeywordState = DEFAULT_STATE, action: KeywordAction): KeywordState => {
  switch (action.type) {
    case KeywordActionType.CHANGE_KEYWORDS:
      return {
        ...state,
        keywordPage: action.payload,
      };
    case KeywordActionType.CHANGE_KEYWORDS_FILTER:
      return {
        ...state,
        filter: action.payload.filters,
      };
    default:
      return state;
  }
};
